// RITA-1498 (Nutzungserfassung Phase 1b) — freie Aktionen aus dem Code melden (Konzept 3.4).
// useTrack()('export.csv', { format: 'csv' }) → action-Ereignis. Zusatzfelder: höchstens 8,
// Schlüssel ≤ 32, Strings ≤ 64 Zeichen (Servergrenze); nie Eingabewerte oder Namen übergeben.
import { createContext, useContext } from 'react';
import type { UsagePropValue } from 'global-intern-types';

export type TrackAction = (name: string, props?: Record<string, UsagePropValue>) => void;

/**
 * Zustand der Erfassung, wie der Provider ihn kennt (RITA-1505):
 * true = läuft, false = BESTÄTIGT abgeschaltet, null = noch keine Antwort.
 *
 * Die drei Werte sind Absicht: configClient.ts ist fail-closed und liefert bei fehlendem Token,
 * bei einem 401/500 und bei einem Netzaussetzer dasselbe 'aus'. Wer daraus einen Hinweis
 * „Erfassung: ausgeschaltet“ baut, würde bei jeder Störung eine Unwahrheit anzeigen. Solange
 * nichts bekannt ist, sagt der Context deshalb null und der Verbraucher schweigt.
 */
export type UsageTrackingEnabled = boolean | null;

export interface UsageTrackingContextValue {
  track: TrackAction;
  enabled: UsageTrackingEnabled;
}

export const UsageTrackingContext = createContext<UsageTrackingContextValue>({
  track: () => undefined,
  enabled: null,
});

export const useTrack = (): TrackAction => useContext(UsageTrackingContext).track;

/** true = Erfassung läuft, false = bestätigt aus, null = unbekannt (siehe UsageTrackingEnabled). */
export const useUsageTrackingEnabled = (): UsageTrackingEnabled => useContext(UsageTrackingContext).enabled;
